import {
  Alert,
  Checkbox,
  Collapse,
  Divider,
  Input,
  Modal,
  Radio,
  Rate,
  Tag,
  Col,
  Row,
} from 'antd'
import CheckableTag from 'antd/lib/tag/CheckableTag'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import DrawerSkill from 'components/DrawerSkill'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`

export const SectionWrapper = styled(Flex)`
  width: 100%;
  // border: 1px solid ${COLORS.PAGE_BORDER};
  // box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;

  overflow: scroll;
  // background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
     @media only screen and (min-width: 1200px) and (max-width: 1300px) {
  margin: 30px 20px 20px 20px;
}
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    margin: 10px;
  }
`

export const RightDivCol = styled(Col)`
  height: fit-content;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  background: ${COLORS.WHITE};
  border-radius: 10px;
`

export const TopHeader = styled(Flex)`
  padding: ${props => (props.padding ? props.padding : '20px 25px')};
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
  align-items: center;
  text-align: ${props => (props.alignCenter ? 'center' : '')};
  gap: ${props => (props.gap ? props.gap : '0')};
`

export const SubHeading = styled(Flex)`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${COLORS.GREY_P_100};
`
export const ShowNum = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  padding-top: 10px;
  padding-right: 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const AnchorText = styled.a`
  font-style: normal;
  font-weight: 500;
  padding-top: 10px;
  padding-right: 25px;
  font-size: 13px;
  line-height: 18px;
  color: ${props => (props.color ? '#DF3C2B' : `${COLORS.PRIMARY}`)};
`

export const AnchorTextLocation = styled.a`
  font-style: normal;
  font-weight: 500;
  padding-top: 10px;
  padding-right: 25px;
  padding-left: 195px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`

export const ExtraPadding = styled.div`
  margin-bottom: 10px;
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  gap: 20px;
`

export const FilterCollapse = styled(Collapse)`
  background-color: #fafafb !important;
  margin-right: 5px;

  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 10px !important;
    border-radius: 5px;
    color: ${COLORS.GREY_T_60} !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }
`

export const StyleLeft = styled.div`
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  background: ${COLORS.WHITE};
  border-radius: 10px;
  margin: 0 20px;
  padding-bottom: 20px;
`

export const LocationDiv = styled.div`
  height: 200px;
`

export const VerticalDivider = styled(Divider)`
  height: 30px;
`

export const OutlineDiv = styled.div`
  height: 70px;
  padding-top: 10px;
`
export const OutlineDiv1 = styled.div`
  padding-top: 5px;
  padding-bottom: 15px;
`
export const StyledRow = styled(Row)`
  width: 100%;
  padding: 20px 20px;
`
export const RightDiv = styled.div`
  position: absolute;
  right: 0%;
  padding-right: 70px;
`

export const ContentCenterDiv = styled.div`
  text-align: center;
`
export const CenterButton = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
`
export const PaddedLeftFlex = styled(Flex)`
  padding-left: 50px;
  @media only screen and (max-device-width: 767px) {
    padding-left: 0px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    padding-left: 0px;
  }
`

export const StyledFlex = styled.div`
  position: static;
  // padding: 5px 48px 5px 20px;
  width: '100%';
  height: 168px;
  border-radius: 10px;
  border: 1px solid ${props => (props.border ? props.border : '#D9D9D9')};
  background-color: ${props =>
    props.background ? props.background : '#FFFFFF'};
  margin: 20px;
  display: flex;
  align-items: center; /* Vertically center items */
  justify-content: space-between;
  // box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
  //   inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  // &:hover {
  //   background-color: #f8f8f8;
  // }
`

export const Name = styled.div`
  font-weight: 600;
  font-size: 18px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #1b1f22;
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
  @media only screen and (max-device-width: 767px) {
    font-size: 11px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    font-size: 11px;
    line-height: 18px;
  }
`

export const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
`

export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const StyledDrawerSkill = styled(DrawerSkill)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const FooterFlex = styled(Flex)`
  padding: ${props => (props.padding ? props.padding : 0)};

  gap: 20px;
`
export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  color: #343e59;
`
export const PopHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding-top: 15px;
  padding-bottom: 5px;
`
export const PopSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 5px;
`
export const RadioGroups = styled(Radio.Group)`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // @media (max-width: 768px) {
  //   flex-direction: column;
  //   align-items: stretch;
  // }
`
export const SearchInput = styled(Input)`
  &&::placeholder {
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
  }
  .ant-input::placeholder {
    font-weight: 500 !important;
  }
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  width: ${props => (props.width ? props.width : '250px')} !important;
  height: ${props => (props.height ? props.height : '40px')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;
  }
`
export const StyledCheckbox = styled(Checkbox)`
  padding-top: 10px;
  margin-left: 0px !important;
  .ant-checkbox + span {
    padding-left: 12px;
  }
  .ant-checkbox-group-item {
    width: 100%;
    padding-top: 10px;
  }
  .ant-checkbox-wrapper {
    padding: 5px !important;
  }
`
export const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    width: 200px;
    padding-top: 15px;
  }
`
export const FilterChipPanel = styled.div`
  padding: 5px 0px 10px 30px;
`

export const StyledTag = styled(Tag)`
  line-height: 30px;
  background: #f2f3f5;
  border: 1px solid #f2f3f5;
  font-weight: 600;
`

export const RecentHeading = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
  padding: 10px 25px;
`

export const SpinWrapper = styled(Flex)`
  padding-top: 25px;
`
export const NoDataText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: #999fac;
`

export const DetailHeader = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
`

export const LeftText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 14px;
`

export const RightText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #4d566e;
  padding-top: 14px;
`
export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_BASE)};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};
`
export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
`
export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  padding: ${props => (props.padding ? props.padding : '')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  margin-top: 6px;
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
  ${props => props.afterContent && `::after { content: ',';}`}

  :last-child:after {
    content: '';
  }
`

export const SkillList = styled.ul`
  padding-inline-start: 20px;
`
export const QuestionnaireWrapper = styled.div`
  padding: 23px 0px 24px 40px;
  height: 70vh;
  overflow-y: auto;
`
export const QuestionNo = styled.div`
  color: ${COLORS.GREY_T_20};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  // width: 2%;
  line-height: 18px;
`
export const QuestionWrapper = styled.div`
  display: flex;
`

export const Question = styled.div`
  color: ${COLORS.GREY_T_20};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`
export const RedAsterisk = styled.div`
  margin-left: 5px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
`

export const AnsWrapper = styled(Radio.Group)`
  width: ${props => (props.width ? props.width : '20%')};
  margin-top: 15px;
  justify-content: space-between;
  display: flex;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  align-items: ${props => (props.start ? 'start' : 'end')};
`

export const Answer = styled(Flex)`
  color: ${COLORS.GREY_T_30};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  width: ${props => (props.width ? props.width : '5px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : '')};
`
export const QuestionFlex = styled(Flex)`
  gap: 20px;
  width: 98%;
  margin-top: ${props => (props.marginTop ? props.marginTop : 0)};
`
export const Wrapper = styled(Flex)`
  width: 95%;
  flex-direction: column;
`

export const BorderOnlyRadio = styled(Radio)`
  .ant-radio-inner {
    border: 1.5px solid ${COLORS.GREY_T_80};
    background-color: transparent !important;
  }
  margin-top: ${props => (props.marginTop ? props.marginTop : 0)};

  /* Style the Radio button label (optional) */
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
`
export const StyledGroup = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    width: 90%;
    padding-top: 15px;
    margin-top: 5px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    color: ${COLORS.GREY_T_30};
    text-transform: ${props => (props.capitalize ? 'capitalize' : '')};
  }
  .ant-checkbox-inner {
    border: 1.5px solid ${COLORS.GREY_T_80};
  }
`
export const StyledNote = styled.div`
  margin-top: 10px;
  color: #999fac;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 1.96px;
`
export const NoteDiv = styled(Flex)`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
  color: #999fac;
`

export const AlertText = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-left: 5px;
`
export const StyledAlert = styled(Alert)`
  border: none;
  border-radius: 10px;
  margin: ${props => (props?.margin ? props?.margin : 0)};
  ${props =>
    props?.backgroundColor &&
    `background-color: ${props?.backgroundColor};`} margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0'};
  margin-top: ${props => (props.margintop ? props.margintop : '0')};
`

export const Sepreator = styled.div`
  border-left: 1px solid #e6e7ea;
  margin-left: 15px;
  margin-right: 15px;
  height: 55px;
`

export const QuestionnaireSectionWrapper = styled(Flex)`
  width: ${props => props.width ?? '100%'};
  height: 87.7vh;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  // margin: 30px 100px 20px 100px;
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    margin: 10px;
  }
`

export const Content = styled(Flex)`
  height: ${props => (props.height ? props.height : 'auto')};
  background-color: white;
  border: 1px solid #e6e7ea;
  box-shadow: 0px 6px 10px rgba(86, 94, 106, 0.1);
  padding: ${props => (props.smallPadding ? 0 : '50px 75px 50px 75px')};
  gap: 20px;
  border-radius: 10px;
  width: ${props => (props.width ? props.width : '610px')};
`

export const CTCRow = styled(Row)`
  margin-top: 10px;
  margin-right: 20px;
  margin-left: 6px;
  background-color: ${props => getOrderBasedColor(props.orderNo).background};
  border: 1px solid ${props => getOrderBasedColor(props.orderNo).borderColor};
  border-radius: 5px;
`
const getOrderBasedColor = orderNo => {
  if (orderNo === null) {
    return {
      // Default styling
      color: '#000000',
      borderColor: '#DBDBDB',
      background: '#EDEDED1A',
    }
  }
  switch (orderNo) {
    case 1:
      return {
        color: '#000000',
        borderColor: '#CCCCCC',
        background: '#CCCCCC33', // 20% opacity of #CCCCCC
      }
    case 2:
      return {
        color: '#000000',
        borderColor: '#97CADB',
        background: '#97CADB33', // 20% opacity of #97CADB
      }
    case 3:
      return {
        color: '#000000',
        borderColor: '#B5A3F7',
        background: '#B5A3F733', // 20% opacity of #B5A3F7
      }
    case 4:
      return {
        color: '#000000',
        borderColor: '#E1A7BA',
        background: '#E1A7BA33', // 20% opacity of #E1A7BA
      }
    case 5:
      return {
        color: '#000000',
        borderColor: '#F29F05',
        background: '#F29F0533', // 20% opacity of #F29F05
      }
    case 6:
      return {
        color: '#000000',
        borderColor: '#F25C05',
        background: '#F25C0533', // 20% opacity of #F25C05
      }
    case 7:
      return {
        color: '#000000',
        borderColor: '#72B06F',
        background: '#72B06F33', // 20% opacity of #72B06F
      }
    case 8:
      return {
        color: '#000000',
        borderColor: '#4C1D91',
        background: '#4C1D9133', // 20% opacity of #4C1D91
      }
    case 9:
      return {
        color: '#000000',
        borderColor: '#02457A',
        background: '#02457A33', // 20% opacity of #02457A
      }
    case 10:
      return {
        color: '#000000',
        borderColor: '#595F33',
        background: '#595F3333', // 20% opacity of #595F33
      }
    case 11:
      return {
        borderColor: '#000000',
      }
    default:
      return {
        // Default style for unmatched cases
        color: '#000000',
        borderColor: '#DBDBDB',
        background: '#DBDBDB33', // 20% opacity of #DBDBDB
      }
  }
}
export const Container = styled(Flex)`
  height: 93.1vh;
  width: 100vw;
  background-color: #fafafb;
  gap: 40px;
`
export const Spacer = styled.div`
  height: 24px;
`

export const IconDiv = styled.div`
  cursor: pointer;
  padding: 10px 10px 0 0;
`
export const FeedbackWrapper = styled(Flex)`
  flex-direction: column;
  padding: 0px 40px 0px 45px;
`
export const FeedbackHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${COLORS.GREY_P_100};
  text-align: center;
  align-self: center;
`
export const Description = styled(Flex)`
  color: #9f9f9f;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  width: 360px;
  align-self: center;
  margin-top: ${props => (props.mt ? props.mt : 2)};
`

export const CustomRate = styled(Rate)`
  font-size: 35px;
  margin-bottom: 14px;
  margin-top: 14px;
  /* Selected stars color */
  .ant-rate-star:not(.ant-rate-star-zero) {
    color: #3249d7 !important;
  }

  /* Unselected stars color */
  .ant-rate-star-zero svg {
    color: #b6bbd9 !important; /* Red color for unselected stars */
  }

  /* Size and border radius for second star */
  .ant-rate-star-second {
    font-size: 35px !important;
    border-radius: 0 !important;
  }

  /* Hover color for selected stars */
  .ant-rate-star:not(.ant-rate-star-zero):hover :focus {
    color: #3249d7 !important;
  }
  .ant-rate-star-half::before {
    color: #3249d7; /* Selected color for the unselected part of half star */
  }
`
export const FeedbackSubHeading = styled(Flex)`
  color: ${COLORS.GREY_P_100};
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
  margin-bottom: 20px;
`

export const CustomCheckableTags = styled(CheckableTag)`
  border-radius: 10px;
  border: 0.5px solid #3249d782;
  /* width: 100%; */
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 6px 22px;
  gap: 10px;
  height: 40px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin: 0%;
`
export const TagWrapper = styled.div`
  min-width: 115px;
`
export const RoleNameDiv = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #2563eb;
  cursor: pointer;
  white-space: nowrap; /* Prevent text from wrapping to the next line */
  overflow: hidden; /* Hide the overflowed text */
  text-overflow: ellipsis; /* Apply ellipsis (...) when text overflows */
  max-width: 80%;
`
export const TabCount = styled(Flex)`
  width: 47px;
  line-height: 20px;
  border-radius: 5px;
  background-color: ${COLORS.PRIMARY};
  color: ${COLORS.WHITE};
  justify-content: center;
  font-size: 8px;
  font-weight: 500;
`

export const Wrapper1 = styled.div`
  display: flex;
  align-items: center;
  gap: 16px; /* Adjusts spacing between logo and content */
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const NameAdd2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 90%;
`

export const CompanyName = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 17.64px;
  color: #000000;
  white-space: nowrap; /* Prevent text from wrapping to the next line */
  overflow: hidden; /* Hide the overflowed text */
  text-overflow: ellipsis; /* Apply ellipsis (...) when text overflows */
  max-width: 80%;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 17.64px;
  }
`

export const BodyText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-top: -8px;
  color: #000000;
`
export const CTCDiv = styled.div`
  padding-left: 10px;

  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #350640;

  span {
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }
`
export const RightDivStatus = styled.div`
  position: absolute;
  right: 0%;
  margin-right: 30px;
  padding: 0 20px;
  background-color: ${props => (props.color ? props.color : '#CCCCCC')};
  border: 1px solid ${props => (props.border ? props.border : 'none')};
  border-radius: 15px;
  color: #000000;
`
export const RightDivStatus1 = styled.div`
 margin-right: 10px;
  padding: 0 20px;
  background-color: ${props => (props.color ? props.color : '#CCCCCC')};
  border: 1px solid ${props => (props.border ? props.border : 'none')};
  border-radius: 15px;
  color: #000000;
`
export const ApplyText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.05em;
  color: #828282;
  span {
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0.05em;
  }
`

export const ApplyButton = styled(Row)`
  margin-top: 20px;
`

export const CompType = styled.div`
  border-radius: 10px;
  margin: ${props => (props.margin ? props.margin : '0 20px')};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  background: ${COLORS.WHITE};
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.64px;
  padding: 10px;
  cursor: pointer;
`

export const CompTypeInside = styled.div`
  border-radius: 10px;
  margin: 10px 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  background: ${COLORS.WHITE};

  padding: 10px;
`
export const FilterText = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 21px;
  color: #343e59;
  margin-left: 15px;
`
export const FilterTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #343e59;
  margin-left: 15px;
  margin-bottom: ${props => (props.margin ? props.margin : '0px')};
`
export const InputNumberPadding = styled.div`
  margin-left: 15px;
  width: '100%';
`
export const RangeText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 10px;
  color: #343e59;
  padding-top: 15px;
`

export const FilterHeadDiv = styled.div`
  padding-top: 15px;
`
export const RedNote = styled.div`
  margin-top: 2px;
  margin-left: 5px;

  font-size: 12px;
  font-weight: 500;
  color: ${props => (props.color ? props.color : COLORS.ERROR)};
`

export const BlacklistDiv = styled.div`
  padding: 10px 20px;
  border: 1px solid #e35e50;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 10px 20px;
  border-radius: 20px;
  color: #e35e50;

  span {
    font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`

export const LapsedButton = styled.div`
  width: ${props => (props.width ? props.width : '120px')};
  height: ${props => (props.height ? props.height : '40px')};
  background: ${props => (props.background ? props.background : '#F0F0F0')};
  color: ${props => (props.color ? props.color : '#808080')};
  border-radius: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledModal = styled(Modal)`

  .ant-modal-content {
    border-radius: 10px;
   height: 100vh;
  }
  
  .ant-modal-body {
    padding: 10px;
     height: 90vh;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .ant-modal-close {
    display: none;
  }
  
 
  
  .ant-modal-header {
    display: none;
  }
`
export const StyledModal1 = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    position: relative;
    height: 90vh;
    display: flex;
    flex-direction: column;
  }
  
  .ant-modal-body {
    padding: 0;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    form {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .form-content {
      flex: 1;
      overflow-y: auto;
      padding: 20px;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }

    .fixed-footer {
      padding: 16px 20px;
      border-top: 1px solid #f0f0f0;
      background: white;
    }
  }
  
  .ant-modal-close {
    display: none;
  }
  
  .ant-modal-footer {
    display: none;
  }
  
  .ant-modal-header {
    display: none;
  }
`
export const CurrentCourseWrapper = styled.div`
 background-color: #E1FBF1;
 height: 38px;
 font-size: 12px;
 font-weight: 400;
 line-height: 14px;  
 color: #000000;
 display: flex;
 align-items: center;
 justify-content: center;
 border-radius: 10px;
`

export const StyledSelectDiv = styled.div`
  width: 80px;
  .ant-select {
    .ant-select-selector {
      border-radius: 10px 0 0 10px !important;
      border-right: none !important;
      background: #F5F5F5;
    }
  }
`

export const StyledInputDiv = styled.div`
  width: calc(100% - 80px);
  .ant-input {
    border-radius: 0 10px 10px 0 !important;
    border-left: none !important;
    background: #F5F5F5;
  }
`

export const StyledInput = styled(Input)`
  &.ant-input {
    height: 38px;
    background: #F5F5F5;
    border: 1px solid #D9D9D9;
    &:focus, &:hover {
      border-color: #D9D9D9;
      box-shadow: none;
    }
  }
`

export const TitleTextPopup = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: regular;
  line-height: 30px;
  color: #000000;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '20px')}; 
`